/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reset-json-config.vue?vue&type=template&id=5f8dc4fa&"
import script from "./reset-json-config.vue?vue&type=script&lang=js&"
export * from "./reset-json-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports